import { AuthProvider } from './../auth/auth';
import { HttpClient } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV } from '../../environments/environment';

@Injectable()
export class ProvidersProvider {
  private providers: Provider[]; // PROVIDERS
  constructor(public http: HttpClient, private authProvider: AuthProvider) {}

  getProviders() {
    return Observable.create(observer => {
      if (this.providers) {
        // return cached result
        observer.next(this.providers);
      } else {
        this.authProvider.getOptions().subscribe(options => {
          this.http.get(ENV.api + '/api/providers', options).subscribe(
            providersResult => {
              observer.next(providersResult);
            },
            error => {
              observer.error(error);
            }
          );
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/providers/providers.ts